import { Button, colors } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';
import { DocumentAction } from 'types/documentsService';

export interface OptionStylingProps {
  $actionType?: DocumentAction;
}

export const DisabledOptionStyled = styled.li`
  box-sizing: border-box;
  padding: 1.6rem;
  color: ${colors.neutral[400]};
  cursor: not-allowed;

  &::after {
    content: '';
    display: block;
    height: 0.5px;
    width: 100%;
    background-color: ${colors.neutral[400]};
    position: relative;
    bottom: -1.6rem;
  }

  &:last-of-type {
    &::after {
      display: none;
    }
  }

  &:active {
    background-color: transparent;
  }
`;

export const DisabledOptionTextStyled = styled.span<OptionStylingProps>`
  font-size: 1.4rem;
  line-height: 2rem;
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const ActionOptionTextStyled = styled(DisabledOptionTextStyled)<OptionStylingProps>`
  font-size: 1.4rem;
  line-height: 2rem;
`;

export const DropdownButtonStyled = styled(Button)`
  text-transform: uppercase;
  font-weight: 700;
  height: 3.8rem;
`;

export const DropdownOpenedButtonStyled = styled(Button)`
  height: 3.8rem;
  font-weight: 700;
  font-size: 1.4rem;
`;

export const DownloadButtonStyled = styled(Button)`
  text-transform: uppercase;
`;
